module.exports = __webpack_public_path__ + "static/media/The B Major.f7ae1267.png";